// import CustomerTab from '../../components/CustomerTab';
import CustomerHeader from '../../components/CustomerHeader';
import OwnerEmployeesTable from '../../components/owner/OwnerEmployeesTable';
import OwnerSidebar from '../../components/owner/OwnerSidebar';



const OwnerEmployeesScreen = () => {
  return (
    <>
        <section className='dashboard-container flex '>
          <aside className=''>
              <OwnerSidebar />
          </aside>
          <main className='main-container mb-32'>
              <CustomerHeader orderTitle={'Employees'} orderSubtitle={'Manage employees'} showEmployeesButton={true}/>

            <section className='mt-20 flex gap-4'>
              <section>
                <OwnerEmployeesTable/>
              </section>
            </section>
          </main>
        </section>
    </>
    
  )
}

export default OwnerEmployeesScreen